module.exports = __webpack_public_path__ + "img/responsive-phone.491214c8.png";